var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5b369623153055e7efc8c583d60c197595975372"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tempest-gatsby"]={id:"5b369623153055e7efc8c583d60c197595975372"};
      